@export fn displayLogRGB(sample: vec4<f32>) -> vec4<f32> {
  return vec4<f32>(mapLog(sample.r), mapLog(sample.g), mapLog(sample.b), 1.0);
}

fn mapLog(v: f32) -> f32 {
  let d = log(abs(v) + 1.0);
  return fract(d / 16.0);
}
